import { JSX } from 'react';
import { TradingFormState } from './trading-form.types';
import { FormField, FormFieldProps } from '../../foundation/form/form-field';

export const TradingFormField = (
  props: FormFieldProps<TradingFormState>
): JSX.Element => {
  return <FormField<TradingFormState> {...props} />;
};
